import useTranslation from "../hooks/TranslationContext";

type Props = {
  error: Error
};

export default function Error({ error }: Props) {
  const { t } = useTranslation();
  console.error(error);

  return (
    <div>{t("something-went-wrong")}</div>
  );
}
